document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (!toggle) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  menu.classList.toggle('is-open');
  toggle.setAttribute('aria-expanded', menu.classList.contains('is-open') ? 'true' : 'false');
});

// Product image gallery: thumbnails replace the main image, no popup.
(function () {
  const mainImage = document.querySelector('[data-main-image]');
  const thumbs = document.querySelectorAll('[data-product-thumb]');
  if (!mainImage || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const mainSrc = thumb.getAttribute('data-main-src');
      const alt = thumb.getAttribute('data-alt') || 'Product image';
      if (mainSrc) {
        mainImage.src = mainSrc;
        mainImage.srcset = '';
        mainImage.alt = alt;
      }
      thumbs.forEach(function (item) {
        item.classList.remove('is-active');
        item.removeAttribute('aria-current');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-current', 'true');
    });
  });
})();
